<template>
  <div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col>
          <card>
            <b-row align-v="center" slot="header">
              <b-col cols="8">
                <h3 class="mb-0" v-if="!idEdit">Realize seu cadastro</h3>
                <h3 class="mb-0" v-else>Cadastro de Estudante</h3>
              </b-col>
              <b-col cols="4" v-loading="loading" />
            </b-row>

            <b-form @submit.prevent="save" v-loading="loading">
              <!-- Dados de Acesso -->
              <h6 class="heading-small text-muted mb-4">Dados de Acesso</h6>
              <div class="pl-lg-4">
                <b-row>
                  <b-col lg="6">
                    <base-input
                      type="email"
                      label="E-mail de Acesso"
                      name="E-mail de Acesso"
                      placeholder="exemplo@email.com"
                      v-model="user.emailAcesso"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="password"
                      label="Senha"
                      name="Senha"
                      placeholder="Digite sua senha"
                      v-model="user.senha"
                      :disabled="idEdit"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </div>

              <hr class="my-4" />
              <!-- Responsável pela inscrição -->
              <h6 class="heading-small text-muted mb-4">
                Responsável pela inscrição
              </h6>
              <div class="pl-lg-4">
                <b-row>
                  <b-col lg="5">
                    <base-input
                      type="text"
                      label="Nome"
                      name="Nome"
                      placeholder="Digite seu nome"
                      v-model="user.nomeResponsavel"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      type="email"
                      label="E-mail"
                      name="E-mail"
                      placeholder="exemplo@email.com"
                      v-model="user.emailResponsavel"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="3">
                    <base-input
                      type="text"
                      label="Celular"
                      name="Celular"
                      placeholder="(00) 0000-0000"
                      v-model="user.celularResponsavel"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </div>

              <hr class="my-4" />
              <!-- Informações do Grupo -->
              <h6 class="heading-small text-muted mb-4">
                Informações do Grupo
              </h6>
              <div class="pl-lg-4">
                <b-row>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Nome do Grupo"
                      name="Nome do Grupo"
                      placeholder="Digite o nome do grupo"
                      v-model="user.nomeGrupo"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Universidade"
                      name="Universidade"
                      placeholder="Digite o nome da universidade"
                      v-model="user.universidade"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </div>

              <hr class="my-4" />
              <!-- Participantes -->
              <h6 class="heading-small text-muted mb-4">
                Participantes (mínimo 3, máximo 6)
              </h6>

              <b-card
                class="mb-4"
                v-for="(part, index) in user.detalhesEstudante"
                v-bind:key="part.id"
              >
                <b-card-title class="d-flex justify-content-between">
                  Participante {{ index + 1 }}
                  <base-button
                    size="sm"
                    type="danger"
                    v-if="user.detalhesEstudante.length > 1"
                    @click="excluirParticipante(index)"
                    >Excluir</base-button
                  >
                </b-card-title>

                <div class="pl-lg-4">
                  <b-row>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Nome Completo"
                        name="Nome Completo"
                        placeholder="Digite o nome completo do participante"
                        v-model="user.detalhesEstudante[index].nome"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="RA"
                        name="RA"
                        placeholder="Digite o RA do participante"
                        v-model="user.detalhesEstudante[index].ra"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Telefone"
                        name="Telefone"
                        placeholder="Digite o telefone do participante"
                        v-model="user.detalhesEstudante[index].telefone"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="6">
                      <base-input
                        type="email"
                        label="E-mail"
                        name="E-mail"
                        placeholder="Digite o e-mail do participante"
                        v-model="user.detalhesEstudante[index].email"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                </div>
              </b-card>

              <div
                class="d-flex justify-content-center"
                v-if="user.detalhesEstudante.length < 6"
              >
                <base-button type="neutral" @click="addParticipante"
                  >Adicionar Participante</base-button
                >
              </div>

              <hr class="my-4" />
              <!-- Coordenador do Curso -->
              <h6 class="heading-small text-muted mb-4">
                Coordenador do Curso
              </h6>
              <div class="pl-lg-4">
                <b-row>
                  <b-col lg="12">
                    <base-input
                      type="text"
                      label="Nome Completo"
                      name="Nome Completo"
                      placeholder="Digite o nome completo do coordenador do curso"
                      v-model="user.nomeCoordenador"
                    >
                    </base-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6">
                    <base-input
                      type="email"
                      label="E-mail"
                      name="E-mail"
                      placeholder="Digite o e-mail do coordenador do curso"
                      v-model="user.emailCoordenador"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Telefone"
                      name="Telefone"
                      placeholder="Digite o telefone do coordenador do curso"
                      v-model="user.telefoneCoordenador"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </div>

              <hr class="my-4" />
              <div
                class="pl-lg-4 d-flex justify-content-end align-items-center"
              >
                <span class="text-danger mr-3">{{ errorFeedback }}</span>
                <base-button
                  type="primary"
                  native-type="submit"
                  :loading="loading"
                  class="my-4"
                >
                  <span v-if="!idEdit">Cadastrar</span>
                  <span v-else>Salvar</span>
                </base-button>
              </div>
            </b-form>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import api from "@/services/api";
import { login } from "@/services/utils";

export default {
  name: "estudante-form",
  props: {
    userForm: Boolean,
  },
  data() {
    return {
      errorFeedback: "",
      loading: false,
      idEdit: null,
      user: {
        id: "",
        celularResponsavel: "",
        detalhesEstudante: [
          {
            email: "",
            nome: "",
            ra: "",
            telefone: "",
          },
        ],
        emailAcesso: "",
        emailCoordenador: "",
        emailResponsavel: "",
        nomeCoordenador: "",
        nomeGrupo: "",
        nomeResponsavel: "",
        senha: "",
        telefoneCoordenador: "",
        universidade: "",
      },
    };
  },
  methods: {
    login,
    setLoading(loading) {
      this.loading = loading;
    },
    successLogin() {
      this.$router.push("/usuario");
    },
    errorLogin() {
      this.errorFeedback =
        "Ocorreu algum problema ao fazer login com o usuário criado.";
    },
    async save() {
      this.errorFeedback = "";
      this.loading = true;
      try {
        await api.post("/estudante", this.user);
        if (this.userForm) {
          this.errorFeedback = "";
          login(
            this.user.emailAcesso,
            this.user.senha,
            this.setLoading,
            this.successLogin,
            this.errorLogin
          );
        }
      } catch (e) {
        this.errorFeedback =
          "Ocorreu um problema. Por favor, tente novamente mais tarde.";
      } finally {
        this.loading = false;
      }
    },
    addParticipante() {
      const newEstudante = {
        email: "",
        nome: "",
        ra: "",
        telefone: "",
      };
      this.user.detalhesEstudante.push(newEstudante);
    },
    excluirParticipante(index) {
      this.user.detalhesEstudante.splice(index, 1);
    },
  },
  async mounted() {
    this.idEdit = this.$route.params.id;
    if (this.idEdit) {
      this.loading = true;
      try {
        const response = await api.get(`/estudante/${this.idEdit}`);
        this.user = response.data;
      } catch (e) {
        this.$swal(
          "Oops!",
          "Ocorreu um problema ao carregar os dados. Por favor, tente novamente mais tarde."
        );
      } finally {
        this.loading = false;
      }
    } else if (this.$route.params.email) {
      this.user.emailAcesso = this.$route.params.email;
      this.user.senha = this.$route.params.password;
    }
  },
};
</script>
<style></style>
